import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Instalacion/getDeleteSeleccion`, method: 'POST', body: {list}, token: token})
}
